// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.apps-container {
    margin: 20px;
    padding: 0;
  }
  
  .apps-header {
    margin-bottom: 20px;
    font-size: 24px;
    color: #333;
    text-align: left;
  }
  
  .apps-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
  
  .form-field {
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0 0 30px #0129701a;
    padding: 15px;
}
  
 .field-title {
    font-size: 16px;
    font-weight: bold;
    color: #444;
    margin-bottom: 8px;
  }
  
  .apps-input {
    padding: 16px 16px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 6px;
    outline: none;
    width: 100%;
    background-color: #fff;
    box-sizing: border-box;
  }
  
  .apps-submit {
    padding: 10px 20px;
    font-size: 14px;
    color: #fff;
    border: 2px solid #ccc;
    border-radius: 30px; 
    cursor: pointer;
    transition: all 0.3s ease;
  }

.apps-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background-color: #fff;
}

.apps-table-header {
  font-size: 18px;
  text-align: left;
  padding: 10px;
  background-color: #f4f4f4;
}

.apps-table-head {
  color: #fff;
}

.apps-table-row {
  border-bottom: 1px solid #ddd;
}

.apps-table-header-cell,
.apps-table-body-cell {
  padding: 10px;
  text-align: left;
}

.apps-table-body-row:nth-child(even) {
  background-color: #f9f9f9;
}
.apps-table-download-link {
  color: #007bff;
  text-decoration: none;
}

.apps-table-download-link:hover {
  text-decoration: underline;
}
.app-pill {
  background-color: #007bff;
  color: white;
  padding: 8px 15px;
  border-radius: 50px;
  font-size: 14px;
  font-weight: bold;
  white-space: nowrap;
}
.appstv .nav-link
{ 
   border-radius: 30px;
  font-weight: bold;
  color: black;
  margin-left: 3px;
}
.nav-pills .nav-link.active
{
  background-color: rgb(19, 157, 242)!important;
}

.apps-modern-table th {
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.03em;
}

.app-icon {
    width: 42px;
    height: 42px;
    border-radius: 8px;
    object-fit: cover;
}

.btn-primary {
    border-radius: 20px;
    padding: 4px 12px;
    font-size: 13px;
}

.table-hover tbody tr:hover {
    background-color: #f8f9fa;
}

/* Package Name Info Tooltip */
.pkg-info-tooltip {
    display: none;
    position: absolute;
    bottom: calc(100% + 6px);
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: #fff;
    font-size: 12px;
    padding: 5px 10px;
    border-radius: 6px;
    white-space: nowrap;
    z-index: 999;
    pointer-events: none;
}

.pkg-info-tooltip::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid transparent;
    border-top-color: #333;
}

.position-relative.d-inline-flex:hover .pkg-info-tooltip {
    display: block;
}

`, "",{"version":3,"sources":["webpack://./src/Pages/Site/Settings/Apps.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,8BAA8B;IAC9B,aAAa;AACjB;;CAEC;IACG,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;EAC3B;;AAEF;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;GAEG,mBAAmB;EACpB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,6CAA6C;AAC/C;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,kBAAkB;IAClB,wBAAwB;IACxB,SAAS;IACT,2BAA2B;IAC3B,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".apps-container {\n    margin: 20px;\n    padding: 0;\n  }\n  \n  .apps-header {\n    margin-bottom: 20px;\n    font-size: 24px;\n    color: #333;\n    text-align: left;\n  }\n  \n  .apps-form {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n  }\n  \n  .form-field {\n    background-color: #fff;\n    border-radius: 5px;\n    box-shadow: 0 0 30px #0129701a;\n    padding: 15px;\n}\n  \n .field-title {\n    font-size: 16px;\n    font-weight: bold;\n    color: #444;\n    margin-bottom: 8px;\n  }\n  \n  .apps-input {\n    padding: 16px 16px;\n    font-size: 14px;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    outline: none;\n    width: 100%;\n    background-color: #fff;\n    box-sizing: border-box;\n  }\n  \n  .apps-submit {\n    padding: 10px 20px;\n    font-size: 14px;\n    color: #fff;\n    border: 2px solid #ccc;\n    border-radius: 30px; \n    cursor: pointer;\n    transition: all 0.3s ease;\n  }\n\n.apps-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n  background-color: #fff;\n}\n\n.apps-table-header {\n  font-size: 18px;\n  text-align: left;\n  padding: 10px;\n  background-color: #f4f4f4;\n}\n\n.apps-table-head {\n  color: #fff;\n}\n\n.apps-table-row {\n  border-bottom: 1px solid #ddd;\n}\n\n.apps-table-header-cell,\n.apps-table-body-cell {\n  padding: 10px;\n  text-align: left;\n}\n\n.apps-table-body-row:nth-child(even) {\n  background-color: #f9f9f9;\n}\n.apps-table-download-link {\n  color: #007bff;\n  text-decoration: none;\n}\n\n.apps-table-download-link:hover {\n  text-decoration: underline;\n}\n.app-pill {\n  background-color: #007bff;\n  color: white;\n  padding: 8px 15px;\n  border-radius: 50px;\n  font-size: 14px;\n  font-weight: bold;\n  white-space: nowrap;\n}\n.appstv .nav-link\n{ \n   border-radius: 30px;\n  font-weight: bold;\n  color: black;\n  margin-left: 3px;\n}\n.nav-pills .nav-link.active\n{\n  background-color: rgb(19, 157, 242)!important;\n}\n\n.apps-modern-table th {\n    font-size: 13px;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n}\n\n.app-icon {\n    width: 42px;\n    height: 42px;\n    border-radius: 8px;\n    object-fit: cover;\n}\n\n.btn-primary {\n    border-radius: 20px;\n    padding: 4px 12px;\n    font-size: 13px;\n}\n\n.table-hover tbody tr:hover {\n    background-color: #f8f9fa;\n}\n\n/* Package Name Info Tooltip */\n.pkg-info-tooltip {\n    display: none;\n    position: absolute;\n    bottom: calc(100% + 6px);\n    left: 50%;\n    transform: translateX(-50%);\n    background-color: #333;\n    color: #fff;\n    font-size: 12px;\n    padding: 5px 10px;\n    border-radius: 6px;\n    white-space: nowrap;\n    z-index: 999;\n    pointer-events: none;\n}\n\n.pkg-info-tooltip::after {\n    content: \"\";\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border: 5px solid transparent;\n    border-top-color: #333;\n}\n\n.position-relative.d-inline-flex:hover .pkg-info-tooltip {\n    display: block;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
